import { render } from "./Spaces.vue?vue&type=template&id=7cc94bd7&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=js"
export * from "./Spaces.vue?vue&type=script&lang=js"

import "./Spaces.vue?vue&type=style&index=0&id=7cc94bd7&scoped=true&lang=scss"

import exportComponent from "/Users/lgorden/git/Fybr/parking-manager-sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc94bd7"]])

export default __exports__